import TabsItem from '#components/navigation/tabs/tabsItem/TabsItem';
import { Season } from '#types/generated/graphql-types';
import useTranslation from 'next-translate/useTranslation';

type props = {
  item: Season;
  hideSeasonNumbers: boolean;
  isSeasonTabSelected: boolean;
  onSeasonTabClick: () => void;
};

const SeasonTabItem = ({
  item,
  isSeasonTabSelected,
  onSeasonTabClick,
  hideSeasonNumbers,
}: props) => {
  const { t } = useTranslation();

  const defaultSeasonLabel = t('seasonSelectLabel', {
    seasonNumber: item.seasonNumber,
  });

  const seasonLabel =
    item.label?.title &&
    (hideSeasonNumbers
      ? item.label.title
      : `${item.label.title} ${item.seasonNumber}`);

  return (
    <TabsItem
      id={item.id}
      key={item.title}
      text={seasonLabel ?? defaultSeasonLabel}
      ariaSelected={isSeasonTabSelected}
      isButtonStyle={true}
      handleOnClick={onSeasonTabClick}
    />
  );
};

export default SeasonTabItem;
